import React from "react";

/* webpackChunkName: "UsersDesktop" */
const UsersModule = React.lazy(() => import(`./ui/Users`));

export const UsersPage = () => {
  return <UsersModule />;
};
